import React from 'react'

interface Props {
    subTitle: string;
    value: number;
    t: any;
}

const TaskSummary = ({ subTitle, value, t }: Props) => {
    return (
        <div className="pending-tasks-values-container">
            <div className="date-filter">
                <div className="value">{value}</div>
                <div className="subtitle">{t(subTitle)}</div>
            </div>
        </div>

    )
}

export default TaskSummary